module.exports = __webpack_public_path__ + "23d9700535b07eaf76574bf9262ea770.jpg";